import { Component, OnInit,ViewEncapsulation } from '@angular/core';
import { GroupsServices } from '../groups/groups.services';

@Component({
    selector: 'ms-grouplist',
    templateUrl:'./grouplist.component.html',
    encapsulation: ViewEncapsulation.None
})
export class GroupListComponent implements OnInit {
    rows = [];
    constructor(private groupServices:GroupsServices
      ) {}

    ngOnInit(){
        this.groupServices.getDataGroups().subscribe((data:any)=>{
            this.rows=data.groups;
        });
    }

}